import type { MatchResult } from './types';

/** The most recent result set, kept in sessionStorage so "back to results" works after a reload or tab switch. */
const KEY = 'bandwagn.lastResults';
export interface LastResults { name: string; results: MatchResult[]; path: string; at: number }

export function saveLastResults(v: Omit<LastResults, 'at'>) {
  try { sessionStorage.setItem(KEY, JSON.stringify({ ...v, at: Date.now() })); } catch { /* ignore */ }
}
export function loadLastResults(): LastResults | null {
  try { const s = sessionStorage.getItem(KEY); return s ? (JSON.parse(s) as LastResults) : null; } catch { return null; }
}
